import React from "react";
import "./FindSpecializedClinicPage.css";

export default function FindSpecializedClinicPage() {
  return (
    <div className="fd-specialized-clinic">
      <div className="fd-specialized-clinic__header">
        <h1 className="fd-specialized-clinic__title">Find Specialized Clinic</h1>
        <p className="fd-specialized-clinic__subtitle">
          Search specialized clinics for your patients. (Coming next.)
        </p>
      </div>

      <div className="fd-specialized-clinic__panel">
        <div className="fd-specialized-clinic__panelTitle">Search</div>
        <div className="fd-specialized-clinic__empty">
          This page is a placeholder for now. We’ll add filters + results after
          wiring the route and sidebar link.
        </div>
      </div>
    </div>
  );
}
